import { useIsConnectionRestored } from '@tonconnect/ui-react'

export const useIsWalletConnectionRestored = () => {
  const connectionRestored = useIsConnectionRestored()

  return connectionRestored
}
